import { Grid } from "@mui/material";
import { ContentCard } from "@shared";
import { FormikProps } from "formik";

import { nameof } from "@/common/helper/commonHelper";
import {
  CounselorDutyPreferencesFormValues,
  CourtOption,
} from "@/pages/system-settings/tabs/counselors/pages/counselor-detail/pages/duty-preferences/CounselorDutyPreferences.types";
import { useTranslation } from "@/translations";

import { CourtMultiSelect } from "../court-multi-select/CourtMultiSelect";

interface Props {
  formik: FormikProps<CounselorDutyPreferencesFormValues>;
  courtOptions: CourtOption[];
}

export function CourtPreferencesCard({ formik, courtOptions }: Props) {
  const { t } = useTranslation();

  const excludedError = typeof formik.errors.excludedCourtIds === "string" ? formik.errors.excludedCourtIds : undefined;

  return (
    <ContentCard title={t("counselors.dutyPreferences.courts.title")}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <CourtMultiSelect
            label={t("counselors.dutyPreferences.courts.preferred")}
            options={courtOptions}
            value={formik.values.preferredCourtIds}
            onChange={(ids) =>
              void formik.setFieldValue(nameof<CounselorDutyPreferencesFormValues>("preferredCourtIds"), ids)
            }
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <CourtMultiSelect
            label={t("counselors.dutyPreferences.courts.excluded")}
            options={courtOptions}
            value={formik.values.excludedCourtIds}
            onChange={(ids) =>
              void formik.setFieldValue(nameof<CounselorDutyPreferencesFormValues>("excludedCourtIds"), ids)
            }
            placeholder={t("counselors.dutyPreferences.courts.none")}
            helperText={excludedError ?? t("counselors.dutyPreferences.courts.excludedHint")}
            error={!!excludedError}
          />
        </Grid>
      </Grid>
    </ContentCard>
  );
}
